<template>
    <div v-html="content.contentText" class="wysiwyg-content">
    </div>
</template>

<script>
export default {
  props: {
    content: Object
  }
};
</script>

<style  scoped>
.wysiwyg-content{
  width:100%;
  overflow: hidden;
  line-break: auto;
  display: flex;  
  flex-wrap: wrap;
}
</style>